module.exports = __webpack_public_path__ + "img/idea-base@2x.99e97e92.png";